<template>
  <div class="home">
    <NetWork v-if="networkError" @refreshs="refresh"></NetWork>
    <Loading v-else-if="loading" />
    <div v-else class="home-main">
      <!-- 状态步骤条 -->
      <Steps
        :active="active"
        :stepsList="stepsList"
        @changeActive="changeActive"
        :appointmentState="appointmentState"
      />

      <!-- 信息填报 -->
      <template v-if="active === 1">
        <div class="all_city">
          <div class="check_city" v-if="showCityFlag">
            <ul :class="isEmptyCity ? 'c_t_b' : ''">
              <li @click="showCustomPicker('province')">
                <span
                  :class="isGray ? '' : 'city_gray'"
                  :style="{ color: !editCityFlag ? '#c4c4c6' : '' }"
                  >{{ formInfodata.province | ellipsis }}</span
                ><span><img src="@/assets/images/down.png"/></span>
              </li>
              <li @click="showCustomPicker('city')">
                <span
                  :class="isGrayCity ? '' : 'city_gray'"
                  :style="{ color: !editCityFlag ? '#c4c4c6' : '' }"
                  >{{ formInfodata.city | ellipsis }}</span
                ><span><img src="@/assets/images/down.png"/></span>
              </li>
            </ul>
          </div>
          <div class="city_tips_new" v-if="isEmptyCity"><img  src="@/assets/images/errorTips.png"/>省份和城市不能为空</div>
          <!-- 2025.09.24 客诉优化-临时方案：去掉该文案 -->
          <!-- <div class="city_tips" v-if="showCityFlag">
            <div class="city_tips_content">
              <img src="@/assets/images/tishidesc.png" />
              找不到的城市表示该城市暂未开通代驾服务
            </div>
          </div> -->
          <div class="supplierSelection">
            <ul>
              <li
                @click="showCustomPicker('supplierSelection')"
                v-if="showCarTeamFlag"
              >
                <p><span>选择供应商</span></p>
                <p>
                  <span
                    :class="supplierColor ? 'global_gray' : ''"
                    :style="{ color: !editCarTeamFlag ? '#c4c4c6' : '#333333' }"
                    >{{
                      formInfodata.supplierSelection | supplierEllipsis
                    }}</span
                  ><span><img src="@/assets/images/down.png"/></span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="info_content_box">
          <CredentialsCard
            :credentialsData="identityData"
            @examples="examples"
            @srcValue="srcValue"
            :token="uploadToken"
            :ocrSuccess="ocrSuccess"
            :ocrFail="ocrFail"
            :ocrCardBackSuccess="ocrCardBackSuccess"
            :ocrCardBackFail="ocrCardBackFail"
            :checkFrontOrBack="checkFrontOrBack"
            :grcCardMessage="grcCardMessage"
            :grcCardBackMessage="grcCardBackMessage"
          />
          <ComCardInfo
            :formInfodata="formInfodata"
            :showCardInfoTips="showCardInfoTips"
            v-if="
              isShowCardInfo ||
                ocrSuccess ||
                ocrFail ||
                ocrCardBackSuccess ||
                ocrCardBackFail
            "
            :entryRuleState="entryRuleState"
            :ageRule="ageRule"
            :isEmptyDriverName = "isEmptyDriverName"
            :isEmptyIdCard = "isEmptyIdCard"
            :isEmptySex = "isEmptySex"
            :isEmptyIED = "isEmptyIED"
            @receveErrorStatus="receveErrorStatus"
            @receveDateStatus="receveDateStatus"
            @handleHideNameTips="handleHideNameTips"
            @handleHideSexTips="handleHideSexTips"
            @handleHideClassTips="handleHideClassTips"
          ></ComCardInfo>
        </div>
        <div class="info_content_box">
          <CredentialsCard
            :credentialsData="driverData"
            @examples="examples"
            @srcValue="srcValue"
            :token="uploadToken"
            :ocrDriverFrontSuccess="ocrDriverFrontSuccess"
            :ocrDriverFrontFail="ocrDriverFrontFail"
            :ocrDriverBackSuccess="ocrDriverBackSuccess"
            :ocrDriverBackFail="ocrDriverBackFail"
            :checkDriverFrontOrBack="checkDriverFrontOrBack"
            :grcDriverCardMessage="grcDriverCardMessage"
            :grcDriverBackCardMessage="grcDriverBackCardMessage"
          />
          <ComDriverInfo
            :formInfodata="formInfodata"
            v-if="
              isShowDriverInfo ||
                ocrDriverFrontSuccess ||
                ocrDriverFrontFail ||
                ocrDriverBackSuccess ||
                ocrDriverBackFail
            "
            :showDriverTipsInfo="showDriverTipsInfo"
            :driverAgeRule="driverAgeRule"
            :isEmptyDLC="isEmptyDLC"
            :isEmptyFID="isEmptyFID"
            :isEmptyLED="isEmptyLED"
            :isEmptyLFN="isEmptyLFN"
            @receveErrorStatus="receveErrorStatus"
            @handleHideDriverTips="handleHideDriverTips"
            @handleHidelicenseExpiryDateTips="handleHidelicenseExpiryDateTips"
          ></ComDriverInfo>
        </div>
        <div class="info_content_box" v-if="electronicLicenseShow">
          <CredentialsCard
            :credentialsData="electronicDriverData"
            @examplesElectron="examplesElectron"
            @srcValue="srcValue"
            :token="uploadToken"
            :ocrElectronicSuccess="ocrElectronicSuccess"
            :ocrElectronicFail="ocrElectronicFail"
            :electronicMessage="electronicMessage"
            :electronicStatus="electronicStatus"
            :newelectronicMessage="newelectronicMessage"
          />
        </div>
        <!-- <div class="info_around"> -->
          <!-- <div class="info_around" @click="showAround" v-if="showGreenText">
          <p>我有经验</p>
          <p>
            <img src="../../assets/images/mygo.png" :class="showAroundModule? 'rotate_img' : ''"/>
          </p> -->
        <!-- </div> -->
        <!-- 有经验的绿色通道 -->
        <!-- <div class="around_wrap" v-if="showAroundModule">
          <Around @previewImg='previewImg' @receveData='receveData' @receveTime='receveTime' @receveMsg='receveMsg' :receveImageData='receveImageData' :companyNames='companyName' :startTimes='startTime' :endTimes='endTime'  :token="uploadToken"></Around>
          <van-image-preview class="preview" v-model="showPrview" :images="images" >
            <template v-slot:cover >
              <div class="preview_top" :style="{ top: H }"></div>
              <div class="preview_bottom"></div>
              <div class="delete" @click="handlDelete">删除</div>
            </template>
          </van-image-preview>
        </div> -->
      </template>

      <!-- 信息审核 -->
      <template v-else-if="active === 2">
        <ExamineCard :examine="dataExamine" @updataExamine="updataExamine" />
      </template>

      <!-- 审核通过 -->
      <template v-else-if="active === 3">
        <ExamineCard
          :examine="passExamine"
          @updataExamine="updataExamine"
          v-if="appointmentState"
        />
        <TestList />
      </template>

      <!-- 示例弹框 -->
      <ExamplesImg
        :credentialsData="examplesImg"
        @examplesClose="examplesClose"
        :show="show"
      />
    </div>
    <div class="btn_wrap" v-if="active === 1">
      <div
        v-if="active === 1"
        :class="
          !isVisited
            ? 'info_content_dis_btn'
            : 'info_content_dis_btn info_content_btn'
        "
        @click="nextStep"
      >
        下一步
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <customPicker
        :columns="columns"
        @confirmPicker="confirmPicker"
        @cancelPicker="cancelPicker"
      ></customPicker>
    </van-popup>
    <!-- 电子驾驶证扣12分弹框 -->
    <ElectronicDialog
      v-model="showElectronicDialog"
      :title="electronicDailogtitle"
      :showConfirmButton="true"
      :showCancelButton="true"
      :confirmButtonText="confirmButtonText"
      :cancelButtonText="cancelButtonText"
      :beforeClose="handleAction"
      type="defaultTips"
      :message="electronicDailogMessage"
    />
    <!-- 电子驾驶证证件不匹配弹框 -->
    <ElectronicDialog
      v-model="showElectronicPaperDialog"
      title="证件不匹配"
      :showConfirmButton="true"
      :showCancelButton="true"
      confirmButtonText="修改信息，重新上传"
      cancelButtonText="继续提交，由平台人工审核"
      :beforeClose="handlePaperAction"
      type="defaultTips"
      message="系统检测到，您上传的多份证件，不是同一个人。"
    />
    <!-- 注册上限弹框 -->
    <BaseDialog
      v-model="showRegCapDialog"
      title="提示"
      :showConfirmButton="true"
      :showCancelButton="true"
      confirmButtonText="继续"
      cancelButtonText="关闭"
      :beforeClose="handleRegCapAction"
      type="cancelReport"
      :message="regCapMessage"
    />
    <div>
      <van-action-sheet v-model="actionShow" title="电子版驾驶证示例" description="请在“交管12123”APP中点击“驾驶证”按钮后截图上传">
        <div class="actioncontent">
          <img src="../../assets/images/Electronic2.png"/>
          <img src="../../assets/images/Electronic1.png"/>
        </div>
      </van-action-sheet>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { handleBuryPoint, getLocalCity } from "@/utils/tool.js";
// 组件
import Steps from "@/pages/Home/components/HomeSteps.vue";
import CredentialsCard from "@/pages/Home/components/CredentialsCard.vue";
import ExamplesImg from "@/pages/Home/components/ExamplesImg.vue";
import ExamineCard from "@/pages/Home/components/ExamineCard.vue";
import TestList from "@/pages/Home/components/TestList.vue";
import NetWork from "@/components/network";
import Loading from "@/components/loading";
import customPicker from "@/components/customPicker";
import ComCardInfo from "@/pages/Home/components/CardInfo.vue";
import ComDriverInfo from "@/pages/Home/components/DriverInfo.vue";
// 电子驾驶证dialog
import ElectronicDialog from '@/components/electronic-dialog'
import BaseDialog from '@/components/base-dialog';
// 绿色通道组件
import Around from "@/pages/Home/components/Around.vue";
// 图片
import identity from "@/assets/images/identity.png";
import identityR from "@/assets/images/identityR.png";
import identityC from "@/assets/images/identityC.png";
import identityCR from "@/assets/images/identityCR.png";
import driver from "@/assets/images/driver.png";
import driverR from "@/assets/images/driverR.png";
import driverC from "@/assets/images/driverC.png";
import driverCR from "@/assets/images/driverCR.png";
import surprised from "@/assets/images/surprised.png";
import succeed from "@/assets/images/succeed.png";
import dangerous from "@/assets/images/dangerous.png";
import suoluetu from "@/assets/images/suoluetu.png";
// 接口
import {
  reqCommitData,
  reqModule,
  reqFormInfo,
  queryAuditState,
  reqOpenedProvinceCity,
  reqSuppliers,
  reqOcrCardInfo,
  reqOcrDriverInfo,
  reqAgeRule,
  reqGreenChannel,
  reqOcrElectronicInfo,
  reqElectronicLicenseShow,
  reqTransId
} from "@/apis/serviceApi";
import { triggerMonitorTTI } from "@/utils/monitor/common"

export default {
  name: "Home",
  data() {
    return {
      networkError: false, // 网络链接状态
      loading: true, // 加载状态
      active: 1, // 司机状态
      newDefaultParams: {}, // 上传信息
      uploadToken: "", // 上传图片token
      stepsList: [
        // 状态列表
        {
          key: 1,
          text: "信息填报"
        },
        {
          key: 2,
          text: "信息审核"
        },
        {
          key: 3,
          text: "预约路考"
        }
      ],
      show: true, //示例弹框
      examplesImg: {
        //信息信息
        name: null,
        examplesFrontUrl: null, //示例正面图片
        examplesBackUrl: null //示例反面图片
      },
      identityData: {
        //身份证信息
        name: "身份证上传",
        key: "1",
        frontText: "请拍摄本人身份证人像面",
        backText: "请拍摄本人身份证国徽面",
        frontUrl: identityC, //有相机阴影图片
        backUrl: identityCR, //有相机阴影反面图片
        examplesFrontUrl: identity, //示例正面图片
        examplesBackUrl: identityR, //示例反面图片
        frontImg: undefined, //身份证正面图片
        backImg: undefined, //身份证反面图片
        severFrontImg: "", //服务需要的地址
        severBackImg: "" //服务需要的地址
      },
      driverData: {
        //驾驶证信息
        name: "驾驶证上传",
        key: "2",
        frontText: "请拍摄本人驾驶证首页",
        backText: "请拍摄本人驾驶证副页",
        frontUrl: driverC, //有相机阴影图片
        backUrl: driverCR, //有相机阴影反面图片
        examplesFrontUrl: driver, //示例正面图片
        examplesBackUrl: driverR, //示例反面图片
        frontImg: undefined, //驾驶证正面图片
        backImg: undefined, //驾驶证反面图片
        severFrontImg: "", //服务需要的地址
        severBackImg: "" //服务需要的地址
      },
      electronicDriverData: {
        //电子驾驶证信息
        name: "电子版驾驶证上传",
        key: "3",
        frontText: "请在“交管12123”APP中点击“驾驶证”按钮后截图上传",
        frontUrl: suoluetu, //有相机阴影图片
        examplesFrontUrl: driver, //示例正面图片
        frontImg: undefined, //驾驶证正面图片
        severFrontImg: "", //服务需要的地址
      },
      dataExamine: {}, //审核中和驳回信息
      passExamine: {
        //预约成功
        active: "3",
        img: succeed,
        title: "预约成功",
        textTop: "恭喜您预约成功，若您需要更换时段或",
        textBottom: "取消预约，请联系客服"
      },
      //网申申报数据对象
      formInfodata: {
        supplierSelection: "请选择供应商",
        province: "请选择省份",
        city: "请选择城市",
        driverName: "",
        sex: "",
        idCardNo: "",
        driverLicenseClass: "",
        firstIssueDate: "",
        licenseExpiryDate: "",
        idCardFrontImg: "",
        idCardBackImg: "",
        driverLicenseFrontImg: "",
        driverLicenseBackImg: "",
        idCardExpiryDate: "",
        licenseFileNumber: ""
      },
      serviceTel: "", // 电话号码
      // 司邀新增
      // subSource: '',
      appointmentState: false,
      showCityFlag: false,
      editCityFlag: false,
      showCarTeamFlag: false,
      editCarTeamFlag: false,
      tenantId: "",
      supplierData: [],
      coverCityFlag: false,
      coverCarTeamFlag: false,
      newProvince: "",
      provinceCode: "",
      newCity: "",
      cityCode: 0,
      isGrayCity: false,
      isGray: false,
      isDefaultValue: true,
      cityData: [],
      inviteCityCode: "",
      supplierColor: false,
      pickerCode: "",
      showPicker: false,
      columns: [],
      invitrCarTeamId: "",
      isShowCardInfo: false, // 是否展示身份信息
      isShowDriverInfo: false, // 是否展示驾驶证信息
      // 以下为ocr身份识别 正面和反面
      ocrSuccess: false,
      ocrFail: false,
      ocrCardBackSuccess: false,
      ocrCardBackFail: false,
      checkFrontOrBack: "",
      showCardInfoTips: false,
      // 以下为驾驶证信息识别 正面和反面
      ocrDriverFrontSuccess: false,
      ocrDriverFrontFail: false,
      ocrDriverBackSuccess: false,
      ocrDriverBackFail: false,
      checkDriverFrontOrBack: "",
      showDriverTipsInfo: false,
      // 以下为电子驾驶证信息识别
      ocrElectronicSuccess: false,
      ocrElectronicFail: false,
      showElectronicTipsInfo: false,
      // 以下为校验年龄和驾龄
      ageRule: {}, // 年龄校验规则
      driverAgeRule: 0, // 驾龄校验规则
      showAroundModule: false, // 是否展示绿色通道模块
      showGreenText: false, // 是否展示我有经验
      showPrview: false, // 是否展示图片预览
      images: [], // 存放预览图片
      deleteIndex: null, // 删除绿色通道集合索引
      aroundUploadData: [], // 绿色通道照片集合
      receveImageData: [], // 接收绿色通道上传的图片
      showAroundContent: false, // 判断是否展示绿色通道开关
      companyName: "", // 绿色通道备注数据
      startTime: "",
      endTime: "",
      ageTips: true,
      errorTips: true,
      expiryDateTips: true,
      grcCardMessage: "", // 230202 新增识别不合规身份证件
      grcCardBackMessage: "", // 230202 新增识别不合规身份证件
      grcDriverCardMessage: "", // 230202 新增识别不合规驾驶证证件
      grcDriverBackCardMessage: "", // 230202 新增识别不合规驾驶证证件
      electronicMessage: '', // 230525新增识别不合规电子驾驶证
      showElectronicDialog: false, // 230525控制是否展示电子驾驶证弹框
      electronicDailogMessage: '系统识别到您的驾照已扣12分，请按照交管部门规定，处理销分后，再进行信息填报',
      electronicScore: false, // 电子驾照分已扣12分
      electronicDailogtitle: '',
      confirmButtonText: '',
      cancelButtonText: '',
      electronicLicenseShow: true, // 是否展示电子驾驶证模块
      confirmStatus: 0, //确认状态 默认为0，如果为1，表示已知晓三证OCR结果不一致，仍要提交，由平台人工审核
      cumulativeScore: '', // 电子驾驶证识别出来的分数
      generateTime: null, // 电子驾驶证识别出来的生成时间
      electronicStatus: false,
      showElectronicPaperDialog: false, // 控制证件不匹配弹框
      actionShow: false,
      newDriverId: null, // 0531新增白名单司机
      isElectronicResult: false, // 判断电子驾驶证识别是否返回结果
      transId: null, // transId
      newelectronicMessage: '', // 不足三天提示
      showRegCapDialog: false, // 是否显示注册上限弹框
      regCapMessage: '', // 注册上限文案提示
      isEmptyCity: false, // 省份和城市是否为空
      isEmptySs: false, // 供应商是否为空
      isEmptyDriverName: false, // 姓名是否为空
      isEmptyIdCard: false, // 身份证号是否为空
      isEmptySex: false, // 性别是否为空
      isEmptyIED: false, // 身份证有效截止日期是否为空
      isEmptyDLC: false, // 驾驶证类型是否为空
      isEmptyFID: false, // 驾驶证初次领证日期是否为空
      isEmptyLED: false, // 驾驶证有效截止日期是否为空
      isEmptyLFN:false, // 驾驶证编号是否为空
    };
  },
  components: {
    Steps,
    CredentialsCard,
    ExamplesImg,
    ExamineCard,
    TestList,
    NetWork,
    Loading,
    ComCardInfo,
    ComDriverInfo,
    customPicker,
    ElectronicDialog,
    BaseDialog
    // Around
  },

  computed: {
    // 控制按钮是否高亮展示
    isVisited() {
      return this.pass && this.isTrigger;
    },
    // 4张图片全部填写上传后才可以上传
    pass() {
      if (
        this.identityData.frontImg &&
        this.identityData.backImg &&
        this.driverData.frontImg &&
        this.driverData.backImg && (this.electronicDriverData.frontImg || !this.electronicLicenseShow)
      ) {
        return true;
      }
      return false;
    },
    // 控制下一步按钮展示问题
    isTrigger() {
      const {
        province,
        city,
        driverName,
        idCardNo,
        sex,
        driverLicenseClass,
        firstIssueDate,
        licenseExpiryDate,
        supplierSelection,
        idCardExpiryDate,
        licenseFileNumber
      } = this.formInfodata;
      if (
        this.grcCardMessage ||
        this.grcCardBackMessage ||
        this.grcDriverBAackCardMessage ||
        this.grcDriverCardMessage ||
        !idCardExpiryDate ||
        !province ||
        !city ||
        !driverName ||
        !idCardNo ||
        !sex ||
        !driverLicenseClass ||
        !firstIssueDate ||
        !licenseExpiryDate ||
        !licenseFileNumber ||
        !this.isGray ||
        !this.isGrayCity ||
        (this.subSource == "H5_DRIVER_INVITE" &&
          (!supplierSelection || supplierSelection == "请选择供应商"))
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    //获取adcode
    getLocalCity()
      .then(res => {
        if (res && (res.adCode || res.adcode)) {
          const code = res.adCode || res.adcode;
          console.log("获取定位信息Home====", res);
          //  是否开启绿色通道入口
          this.getGreenChannel(code);
        }
      })
      .catch(e => {
        console.log("绿色通道错误信息", e);
      });
  },
  updated() {},
  mounted() {
    // 检测断网
    window.addEventListener("offline", () => {
      console.log("已断网");
      this.networkError = true;
    });
    window.addEventListener("online", () => {
      console.log("网络已连接");
      this.networkError = false;
    });
    const {
      tenantId,
      subSource,
      cityCode,
      proCode,
      carTeamId,
      activityId,
      driverId,
      isInnerApp
    } = this.$route.query;
    localStorage.setItem("tenantId", tenantId);
    // 渠道subSource取值
    this.subSource = subSource;
    // 默认城市code
    this.inviteCityCode = cityCode;
    // 租户id
    this.tenantId = tenantId;
    // 存储各个渠道的城市参数和供应商参数 区分普通招募和其他渠道进入是否缓存对应的数据
    // isInnerApp 是否是端内网申 true 是  false 不是
    if (isInnerApp != 1) {
      sessionStorage.removeItem("innerApps");
      if (subSource) {
        const urlParams = {
          cityCode,
          proCode,
          carTeamId,
          subSource
        };
        // 如果渠道是司邀
        if (subSource && subSource == "H5_DRIVER_INVITE") {
          urlParams.activityId = activityId;
          urlParams.driverId = driverId;
        }
        localStorage.setItem("allParams", JSON.stringify(urlParams));
      } else {
        localStorage.removeItem("allParams");
      }
    } else {
      localStorage.removeItem("allParams");
      sessionStorage.setItem("innerApps", 1);
    }
    // 如果访问渠道是司邀标题如何取值
    if (this.subSource && this.subSource == "H5_DRIVER_INVITE") {
      document.title = "司机邀请";
    } else {
      document.title = "司机招募";
    }
    // 带有渠道区分的进行获取供应商
    if (this.subSource) {
      this.getSuppliers(this.inviteCityCode);
    }
    // 获取transid
    this.getTransId()
    // 获取开城城市
    this.getOpenedProvinceCity();
    // 获取网申状态
    this.getActiveState();
    //获取客服电话
    if(tenantId) {
      reqModule({
        group: "driver",
        moduleName: "copywriter",
        tenantId,
        channel: "serviceTel"
      }).then(res => {
        if (res.code) {
          this.serviceTel =
            res.data && res.data.values && res.data.values.serviceTel;
        }
      });
    } else {
      handleBuryPoint("recruiting-Information", "selectTenantIdExc", {});
    }
    triggerMonitorTTI();
  },
  filters: {
    // 文字过长显示省略号过滤器
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 7) {
        return value.slice(0, 7) + "...";
      }
      return value;
    },
    supplierEllipsis(value) {
      if (!value) return "";
      if (value.length > 11) {
        return value.slice(0, 11) + "...";
      }
      return value;
    }
  },
  methods: {
    // 控制驾驶证是否展示类型必填提示
    handleHideDriverTips (val) {
      this.isEmptyDLC = val
      this.isEmptyFID = val
    },
    handleHidelicenseExpiryDateTips (val) {
      this.isEmptyLED = false
    },
    // 控制是否展示性别必填提示
    handleHideSexTips (val) {
      this.isEmptySex = val
    },
    // 控制是否展示身份证有效期必填提示
    handleHideClassTips (val) {
      this.isEmptyIED = val
    },
    // 控制是否展示姓名必填提示
    handleHideNameTips (val) {
      this.isEmptyDriverName = val
    },
    // 注册上限事件
    handleRegCapAction (event) {
      if (event == 'confirm') {
        this.showRegCapDialog = false
        this.submitFormInfo(1)
      } else if (event == 'cancel') {
        this.showRegCapDialog = false
      }
    },

    examplesElectron () {
      this.actionShow = true
    },
    receveErrorStatus(val) {
      this.ageTips = val.ageTips;
      this.errorTips = val.errorTips;
      this.isEmptyIdCard = val.isEmptyIdCard
      this.isEmptyLFN = val.isEmptyLFN
    },
    receveDateStatus(val) {
      this.expiryDateTips = val.expiryDateTips;
      this.isEmptyIED = val.isEmptyIED
    },
    // 接收绿色通道备注信息
    receveMsg(msg) {
      this.companyName = msg;
    },
    // 接收上传的绿色通道图片
    receveData(data) {
      if (data.url) {
        this.receveImageData.push({ url: data.url, base64Url: data.base64Url });
      }
    },
    receveTime(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
    },
    // 是否展示绿色通道
    getGreenChannel(adcode) {
      const { tenantId } = this.$route.query;
      reqGreenChannel({ adcode, tenantId, domainType: 200 }).then(res => {
        console.log("绿色通道数据>>>", res);
        if (res.code == 1) {
          res.data = true;
          this.showGreenText = res.data;
          this.showAroundContent = true;
        } else {
          this.showAroundContent = false;
        }
      });
    },
    // 获取transId 0724
    getTransId() {
      const { tenantId } = this.$route.query;
      reqTransId({scene: 1, tenantId, domainType: 200}).then(res => {
        if (res.code == 1) {
          console.log(res, 'transId')
          this.transId = res && res.data && res.data.transId
        }
      })
    },
    // 预览时删除绿色通道数据
    handlDelete() {
      // 关闭预览窗口
      this.showPrview = false;
      // 根据对应的索引删除对应的绿色通道上传的图片数据
      this.receveImageData.splice(this.deleteIndex, 1);
    },
    // 预览图片
    previewImg(data, uploadData) {
      console.log("预览数据====", data);
      this.aroundUploadData = uploadData;
      this.showPrview = true;
      this.images = [data.item.base64Url];
      this.deleteIndex = data.index;
    },
    // 我有经验
    showAround() {
      this.showAroundModule = !this.showAroundModule;
    },
    // 获取年龄和驾龄规则
    getAgeRule(newDriverId) {
      reqAgeRule({ tenantId: this.tenantId, domainType: 200, driverId: newDriverId}, 7000)
        .then(res => {
          console.log({ tenantId: this.tenantId, domainType: 200, driverId: newDriverId }, '年龄限制参数')
          console.log(res, '获取年龄限制')
          const ruleData = res && res.data;
          this.ageRule = ruleData.driverAge;
          this.driverAgeRule = ruleData.driverDrivingAge;
          console.log(res, "ageeeee");
        })
        .catch(err => {
          console.log(err, "000000");
        });
    },
    // 获取开城城市
    getOpenedProvinceCity() {
      console.log({ tenantId: this.tenantId, domainType: 200 }, "-----");
      reqOpenedProvinceCity(
        { tenantId: this.tenantId, domainType: 200 },
        7000
      ).then(data => {
        const newCityData = data && data.data;
        console.log("获取开城数据==", newCityData);
        for (let i = 0; i < newCityData.length; i++) {
          this.cityData.push(newCityData[i]);
        }
        this.getFormInfo();
      });
    },
    // 统一处理获取地址栏code展示城市
    formatCityShow(proCode, cityCode) {
      console.log(proCode, "procode");
      console.log(cityCode, "citycode");
      for (let i = 0; i < this.cityData.length; i++) {
        if (this.cityData[i].provinceCode == proCode) {
          this.newProvince = this.cityData[i].provinceName;
          this.provinceCode = this.cityData[i].provinceCode;
          console.log(this.provinceCode, "code");
          const citys = this.cityData[i].children;
          this.isGrayCity = true;
          this.isGray = true;
          for (let j = 0; j < citys.length; j++) {
            if (citys[j].cityCode == cityCode) {
              this.newCity = citys[j].cityName;
              this.cityCode = citys[j].cityCode;
              this.isGrayCity = true;
              break;
            } else {
              this.isGrayCity = false;
              this.newCity = "请选择城市";
            }
          }
          break;
        } else {
          this.isGrayCity = false;
          this.isGray = false;
          this.newCity = "请选择城市";
          this.newProvince = "请选择省份";
        }
      }
    },
    // 点击对应的picker项
    showCustomPicker(val) {
      this.pickerCode = val;
      const { subSource } = this.$route.query;
      if (this.pickerCode == "province") {
        if (subSource == "H5_SUPPLIER_SHARE" || subSource == "EXCEL_IMPORT") {
          return;
        } else {
          const columsData = [];
          for (let i = 0; i < this.cityData.length; i++) {
            columsData.push(this.cityData[i].provinceName);
          }
          this.columns = columsData;
        }
      } else if (this.pickerCode == "city") {
        if (!this.editCityFlag) {
          return;
        } else {
          if (
            this.formInfodata.province == "请选择省份" ||
            this.formInfodata.province == ""
          ) {
            this.$toast("请选择省份");
            return;
          }
          const columsCityData = [];
          for (let i = 0; i < this.cityData.length; i++) {
            if (this.formInfodata.province == this.cityData[i].provinceName) {
              for (let j = 0; j < this.cityData[i].children.length; j++) {
                columsCityData.push(this.cityData[i].children[j].cityName);
              }
            }
          }
          this.columns = columsCityData;
        }
      } else if (this.pickerCode == "supplierSelection") {
        if (!this.editCarTeamFlag) {
          return;
        } else {
          if (
            this.formInfodata.city == "请选择城市" ||
            this.formInfodata.province == ""
          ) {
            this.$toast("请选择城市");
            return;
          }
          const newSupplierData = [];
          if (this.cityCode == this.inviteCityCode) {
            const { carTeamId } = this.$route.query;
            for (let i = 0; i < this.supplierData.length; i++) {
              if (carTeamId == this.supplierData[i].carTeamId) {
                this.invitrCarTeamId = this.supplierData[i].carTeamId;
                this.invitrCarTeamName = this.supplierData[i].supplierName;
                newSupplierData.push(this.supplierData[i].supplierName);
              }
            }
            this.columns = newSupplierData;
          } else {
            if (
              this.subSource == "H5_DRIVER_INVITE" &&
              this.invitrCarTeamId &&
              this.isDefaultValue
            ) {
              for (let i = 0; i < this.supplierData.length; i++) {
                if (this.invitrCarTeamId == this.supplierData[i].carTeamId) {
                  this.invitrCarTeamId = this.supplierData[i].carTeamId;
                  this.invitrCarTeamName = this.supplierData[i].supplierName;
                  newSupplierData.push(this.supplierData[i].supplierName);
                }
              }
              this.columns = newSupplierData;
            } else {
              for (let i = 0; i < this.supplierData.length; i++) {
                this.invitrCarTeamId = this.supplierData[i].carTeamId;
                this.invitrCarTeamName = this.supplierData[i].supplierName;
                newSupplierData.push(this.supplierData[i].supplierName);
              }
              this.columns = newSupplierData;
            }
          }
        }
      }
      this.showPicker = true;
    },
    cancelPicker({ showPicker }) {
      this.showPicker = showPicker;
    },
    // 确认选择的picker值
    confirmPicker({ data, value, showPicker }) {
      if (this.pickerCode == "province") {
        handleBuryPoint("recruiting-Information", "selectProvince_Click", {});
        this.isGray = true;
        localStorage.setItem("prevValue", this.formInfodata.province);
        this.formInfodata.province = value;
        let prevValue = localStorage.getItem("prevValue");
        if (prevValue != value) {
          this.isGrayCity = false;
          this.formInfodata.city = "请选择城市";
        }
        for (let i = 0; i < this.cityData.length; i++) {
          if (this.formInfodata.province == this.cityData[i].provinceName) {
            this.provinceData = this.cityData[i].children;
            this.provinceCode = this.cityData[i].provinceCode;
            console.log(this.provinceCode, "-----");
          }
        }
        if (
          this.formInfodata.city == "请选择城市" ||
          this.formInfodata.city == ""
        ) {
          this.supplierColor = true;
          this.formInfodata.supplierSelection = "请选择供应商";
        }
      } else if (this.pickerCode == "city") {
        handleBuryPoint("recruiting-Information", "selectTheCity_Click", {});
        this.isGrayCity = true;
        this.formInfodata.city = value;
        this.isDefaultValue = false;
        for (let i = 0; i < this.cityData.length; i++) {
          const citys = this.cityData[i].children;
          for (let j = 0; j < citys.length; j++) {
            if (this.formInfodata.city == citys[j].cityName) {
              this.cityCode = citys[j].cityCode;
              localStorage.setItem(this.phone + "newInviteCode", this.cityCode);
            }
          }
        }
        this.supplierColor = true;
        this.formInfodata.supplierSelection = "请选择供应商";
        this.firstSupplierSelectionValue = false;
        this.getElectronicLicenseShow(this.cityCode)
        this.getSuppliers(this.cityCode);
        this.isEmptyCity = false
      } else if (this.pickerCode == "supplierSelection") {
        this.formInfodata.supplierSelection = value;
        this.isEmptySs = false
        for (let i = 0; i < this.supplierData.length; i++) {
          if (
            this.formInfodata.supplierSelection ==
            this.supplierData[i].supplierName
          ) {
            this.invitrCarTeamId = this.supplierData[i].carTeamId;
            this.supplierColor = false;
            this.invitrCarTeamName = this.supplierData[i].supplierName;
          }
        }
      }
      this.showPicker = showPicker;
    },
    // 获取城市供应商
    async getSuppliers(cityCode) {
      const data = await reqSuppliers({
        tenantId: this.tenantId,
        domainType: 200,
        cityCode
      });
      console.log("参数==", {
        tenantId: this.tenantId,
        domainType: 200,
        cityCode
      });
      if (data.code === 1) {
        console.log("供应商数据==", data);
        this.supplierData = data && data.data;
        if (this.isDefaultValue) {
          this.supplierColor = false;
        } else {
          this.supplierColor = true;
        }
      }
    },
    // 获取表单信息
    getFormInfo() {
      const { subSource, proCode, cityCode } = this.$route.query;
      console.log(
        {
          tenantId: this.tenantId,
          domainType: 200,
          subSource: this.$route.query.subSource,
          proCode,
          cityCode
        },
        "获取表单信息参数"
      );
      reqFormInfo(
        {
          tenantId: this.tenantId,
          domainType: 200,
          subSource: this.$route.query.subSource
        },
        7000
      ).then(data => {
        console.log("获取表单数据===", data);
        if (data.code == 1) {
          const newFormData = data.data.formData;
          this.newDriverId = data.data.driverId
          // 获取年龄和驾龄的准入规则
          if (this.newDriverId) {
            handleBuryPoint("recruiting-Information", "showDriverId", {driverId: this.newDriverId});
            this.getAgeRule(this.newDriverId);
          }
          const {
            greenChannelPicList,
            companyName,
            workingHoursStartTime,
            workingHoursEndTime
          } = (data && data.data.entryAdditionalVO) || {};
          if (data && data.data && data.data.entryAdditionalVO) {
            this.companyName = companyName;
            this.startTime = workingHoursStartTime;
            this.endTime = workingHoursEndTime;
            const list = greenChannelPicList;
            const resultList = list.map((item, index) => {
              return {
                base64Url: item,
                url: item
              };
            });
            this.receveImageData = resultList;
            // 是否默认展示绿色通道模块
            if (this.receveImageData.length > 0) {
              this.showAroundModule = true;
            }
          }
          this.uploadToken = data.data.uploadToken;
          const allData = data.data;
          // 是否展示城市
          const cityFlag =
            allData.fieldConditionVO.city.showFlag &&
            allData.fieldConditionVO.province.showFlag;
          this.showCityFlag = cityFlag;
          // 是否展示供应商
          const carTeamIdFlag = allData.fieldConditionVO.carTeamId;
          this.showCarTeamFlag = carTeamIdFlag.showFlag;

          // 是否支持编辑城市
          const editCityFlag =
            allData.fieldConditionVO.city.editFlag &&
            allData.fieldConditionVO.province.editFlag;
          this.editCityFlag = editCityFlag;

          // 是否支持编辑供应商
          const editCarTeamId = allData.fieldConditionVO.carTeamId;
          this.editCarTeamFlag = editCarTeamId.editFlag;

          //是否覆盖城市
          const coverCityFlag =
            allData.fieldConditionVO.city.coverFlag &&
            allData.fieldConditionVO.province.coverFlag;
          this.coverCityFlag = coverCityFlag;

          // 是否覆盖供应商
          const coverCarTeamId = allData.fieldConditionVO.carTeamId;
          this.coverCarTeamFlag = coverCarTeamId.coverFlag;

          this.formDataInfo = newFormData;
          this.entryRuleState = data.data.entryRuleVO.openState;
          this.formContent = true;
          for (let i = 0; i < this.supplierData.length; i++) {
            if (this.$route.query.carTeamId == this.supplierData[i].carTeamId) {
              this.invitrCarTeamId = this.supplierData[i].carTeamId;
              this.invitrCarTeamName = this.supplierData[i].supplierName;
            }
          }
          // 控制城市和供应商走服务结果还是被地址栏覆盖
          (!subSource || subSource == 'APP_UNION' || subSource == 'APP_ORDINARY') && !this.coverCityFlag && !this.coverCarTeamFlag
            ? this.formatCityShow(newFormData?.province, newFormData?.city)
              : this.formatCityShow(proCode, cityCode);
          // 加载时判断是否要展示电子驾驶证
          (!subSource || subSource == 'APP_UNION' || subSource == 'APP_ORDINARY') && !this.coverCityFlag && !this.coverCarTeamFlag
          ? this.getElectronicLicenseShow(newFormData?.city)
          : this.getElectronicLicenseShow(cityCode)
          if (!this.isDefaultValue) {
            this.supplierColor = true;
            this.formInfodata.supplierSelection = "请选择供应商";
          } else {
            this.supplierColor = false;
            this.formInfodata.supplierSelection = this.invitrCarTeamName;
          }
          if (
            subSource == "H5_SUPPLIER_SHARE" ||
            subSource == "H5_DRIVER_INVITE"
          ) {
            this.formInfodata.province = this.newProvince;
            this.formInfodata.city = this.newCity;
          } else if (subSource == "H5_GD_UNION") {
            this.isGray = true;
            this.isGrayCity = true;
          }
          if (this.formDataInfo) {
            this.setShowImg();
          }
          if (
            newFormData &&
            newFormData.idCardFrontImg &&
            newFormData &&
            newFormData.idCardBackImg
          ) {
            this.isShowCardInfo = true;
          }
          if (
            newFormData &&
            newFormData.driverLicenseFrontImg &&
            newFormData &&
            newFormData.driverLicenseBackImg
          ) {
            this.isShowDriverInfo = true;
          }
          this.formInfodata = {
            province: this.newProvince,
            city: this.newCity,
            driverName: newFormData && newFormData.driverName,
            sex:
              newFormData && newFormData.sex
                ? newFormData && newFormData.sex == 1
                  ? "男"
                  : "女"
                : "",
            idCardNo: newFormData && newFormData.idCardNo,
            driverLicenseClass: newFormData && newFormData.driverLicenseClass,
            firstIssueDate: dayjs(
              newFormData && newFormData.firstIssueDate
            ).format("YYYY-MM-DD"),
            licenseExpiryDate: dayjs(
              newFormData && newFormData.licenseExpiryDate
            ).format("YYYY-MM-DD"),
            licenseFileNumber: newFormData && newFormData.licenseFileNumber,
            idCardExpiryDate:
              newFormData && newFormData.idCardExpiryDate
                ? dayjs(newFormData && newFormData.idCardExpiryDate).format(
                    "YYYY-MM-DD"
                  )
                : "",
            idCardFrontImg: newFormData && newFormData.idCardFrontImg,
            idCardBackImg: newFormData && newFormData.idCardBackImg,
            driverLicenseFrontImg:
              newFormData && newFormData.driverLicenseFrontImg,
            driverLicenseBackImg:
              newFormData && newFormData.driverLicenseBackImg,
            supplierSelection: !this.subSource ? true : this.invitrCarTeamName
          };
        }
      });
    },
    // 获取电子驾驶证是否展示
    getElectronicLicenseShow (adcode) {
      const { tenantId } = this.$route.query;
      console.log(adcode, '是否展示电子驾照分')
      reqElectronicLicenseShow({tenantId, adcode, domainType: 200}, 7000).then(res => {
        console.log(res, '电子驾驶证是否展示')
        this.electronicLicenseShow = res.data
      })
    },
    // 网申获取状态
    getActiveState() {
      const { tenantId } = this.$route.query;
      queryAuditState({ tenantId, domainType: 200 }, 7000).then(res => {
        if (res.code == 1) {
          const { state, rejectReason, appointmentState } = res.data;
          console.log(state, "state");
          console.log(appointmentState, "appointmentState");
          this.appointmentState = appointmentState;
          if (state == 10) {
            //未提交
            this.active = 1;
            handleBuryPoint("recruiting-Information", "show", {});
          } else if (state == 20) {
            //待审核
            this.active = 2;
            handleBuryPoint("recruiting-Audit", "show", { show: state });
            this.setDataExamine("20");
          } else if (state == 30) {
            //驳回
            this.active = 2;
            handleBuryPoint("recruiting-Audit", "show", { show: state });
            this.setDataExamine("30", rejectReason);
          } else if (state == 40 || state == 50) {
            //40通过50转正
            this.active = 3;
            handleBuryPoint("recruiting-Approved", "show", {});
          } else {
            this.active = 1;
            handleBuryPoint("recruiting-Information", "show", {});
          }
        } else {
          this.$toast(res.msg);
        }
        this.loading = false;
      });
    },
    //更改网申状态
    changeActive(val) {
      if (val == 1) {
        handleBuryPoint("recruiting-Information", "show", {});
      }
      this.active = val;
    },
    //判断司机网申状态
    setDataExamine(val, rejectReason) {
      if (val == "20") {
        this.dataExamine = {
          active: "1",
          img: surprised,
          title: "报名信息已提交，审核中…",
          textTop: "您的信息已提交审核，1-3工作日",
          textBottom: "之内给您答复，请耐心等待"
        };
      } else if (val == "30") {
        this.dataExamine = {
          img: dangerous,
          active: "2",
          title: "审核未通过",
          textTop: "您的申请资料未审核通过哦，原因如下：",
          textBottom: rejectReason
        };
      }
    },
    // 回显图片
    setShowImg() {
      const {
        idCardFrontImg,
        idCardBackImg,
        driverLicenseFrontImg,
        driverLicenseBackImg,
        electronicLicenseImg
      } = this.formDataInfo;
      //设置图片
      if (idCardFrontImg) {
        this.identityData.severFrontImg = idCardFrontImg; //上传用的正面地址
        this.identityData.frontImg = idCardFrontImg; //回显用到的地址
        this.identityData.frontText = "身份证人像面"; //证件标题
      }
      if (idCardBackImg) {
        this.identityData.severBackImg = idCardBackImg;
        this.identityData.backImg = idCardBackImg;
        this.identityData.backText = "身份证国徽面";
      }
      if (driverLicenseFrontImg) {
        this.driverData.severFrontImg = driverLicenseFrontImg;
        this.driverData.frontImg = driverLicenseFrontImg;
        this.driverData.frontText = "驾驶证首页";
      }
      if (driverLicenseBackImg) {
        this.driverData.severBackImg = driverLicenseBackImg;
        this.driverData.backImg = driverLicenseBackImg;
        this.driverData.backText = "驾驶证副页";
      }
      if (electronicLicenseImg) {
        this.isElectronicResult = true
        this.electronicDriverData.severFrontImg = electronicLicenseImg
        this.electronicDriverData.frontImg = electronicLicenseImg,
        this.electronicDriverData.frontText = "电子驾驶证";
      }
    },
    // 提交表单信息
    async submitFormInfo(confirmRegisterLimit) {
      const toastSubmit = this.$toast.loading({
        message: "提交中...",
        overlay: true,
        duration: 0,
        forbidClick: true,
        loadingType: "spinner"
      });
      if (
        !/^(\d{4})-(\d{2})-(\d{2})$/.test(this.formInfodata.idCardExpiryDate) ||
        this.formInfodata.idCardExpiryDate == "Invalid Date"
      ) {
        this.$toast("请选择正确的身份证有效截止日期");
        return;
      }
      if (
        this.formInfodata.firstIssueDate > this.formInfodata.licenseExpiryDate
      ) {
        this.$toast("初次领证的日期不能大于有效截止日期");
        return;
      }

      const idNumberReg = /^\d{12}$/;
      if (!idNumberReg.test(this.formInfodata.licenseFileNumber)) {
        this.$toast("请输入正确的驾驶证档案编号");
        return;
      }

      const {
        subSource,
        proCode,
        cityCode,
        activityId,
        driverId
      } = this.$route.query;
      if (subSource == "H5_GD_UNION") {
        this.provinceCode = proCode;
        this.cityCode = cityCode;
      }

      const receveChannelList = this.receveImageData.map((item, index) => {
        return item.url;
      });
      console.log(receveChannelList, "looddd");
      // 解决初次提交展示电子驾驶证模块带有电子驾驶证数据驳回后切换城市不展示电子驾驶证模块仍然传递电子驾驶证数据
      if (!this.electronicLicenseShow) {
        this.electronicDriverData.severFrontImg = null
        this.isElectronicResult = true
      }
      const defaultParams = {
        formDataJsonStr: {
          province: this.provinceCode,
          city: this.cityCode,
          driverName: this.formInfodata.driverName,
          sex: this.formInfodata.sex == "男" ? 1 : 2,
          idCardNo: this.formInfodata.idCardNo,
          driverLicenseClass: this.formInfodata.driverLicenseClass,
          firstIssueDate: this.formInfodata.firstIssueDate,
          idCardExpiryDate: this.formInfodata.idCardExpiryDate,
          licenseExpiryDate: this.formInfodata.licenseExpiryDate,
          licenseFileNumber: this.formInfodata.licenseFileNumber,
          idCardFrontImg: this.identityData.severFrontImg,
          idCardBackImg: this.identityData.severBackImg,
          driverLicenseFrontImg: this.driverData.severFrontImg,
          driverLicenseBackImg: this.driverData.severBackImg,
          electronicLicenseImg: this.electronicDriverData.severFrontImg,
          serviceVersion: 2,
          confirmStatus: this.confirmStatus,
          cumulativeScore: this.cumulativeScore,
          generateTime: this.generateTime
        },
        // 司邀
        inviteDriverActivityStr: {
          activityId,
          inviterId: driverId
        },
        //  绿色通道
        entryAdditionalStr: {
          greenChannelPicList: receveChannelList,
          companyName: this.companyName,
          workingHoursStartTime: this.startTime,
          workingHoursEndTime: this.endTime
        },
        completeFlag: true, //提交信息是否完整
        subSource: this.subSource ? this.subSource : "",
        domainType: 200,
        tenantId: this.tenantId,
        transId:this.transId
      };
      if (subSource == "H5_SUPPLIER_SHARE" || subSource == "H5_DRIVER_INVITE") {
        defaultParams.formDataJsonStr.carTeamId = this.invitrCarTeamId;
      }
      let paramsData = JSON.parse(JSON.stringify(defaultParams));
      if (subSource == "H5_DRIVER_INVITE") {
        paramsData.inviteDriverActivityStr = JSON.stringify(
          paramsData.inviteDriverActivityStr
        );
      } else {
        paramsData.inviteDriverActivityStr = "";
      }
      // 240425新增注册渠道上限
      if (confirmRegisterLimit === 1) {
        paramsData.confirmRegisterLimit = confirmRegisterLimit
      }
      paramsData.formDataJsonStr = JSON.stringify(paramsData.formDataJsonStr);
      paramsData.entryAdditionalStr = JSON.stringify(
        paramsData.entryAdditionalStr
      );

      console.log("提交的信息", defaultParams);
      console.log("提交的信息", paramsData);
      // 判断电子驾驶证是否结果已经返回
      if (!this.isElectronicResult) {
        this.$toast('证件校验中，请稍后再试');
        return
      }
      const data = await reqCommitData({ ...paramsData });
      if (data.code == 1) {
        toastSubmit.clear();
        // 信息填报
        this.active = 2;
        // 获取网申状态
        this.getActiveState();
      } else if (data.code === 10006) {
        toastSubmit.clear();
        // 命中注册上限
        this.showRegCapDialog = true
        this.regCapMessage = data.msg
      } else if (data.code === 600001){
        toastSubmit.clear();
        this.showElectronicPaperDialog = true
      } else {
        toastSubmit.clear();
        this.$toast(data.msg);
      }
    },
    // 下一步
    nextStep() {
      handleBuryPoint("recruiting-Information", "nextButton_Click", {});
      if (this.isTrigger && this.pass) {
        this.confirmStatus = 0
        this.submitFormInfo();
        handleBuryPoint("recruiting-Certificate", "show", {});
      } else {
      const idNumberReg = /^(\d{6}(18|19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$)|(^\d{8}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3})$/
      // 身份证相关
      if (this.showCityFlag && this.formInfodata.city === '请选择城市') {
         this.$toast('城市不能为空');
         this.isEmptyCity = true
         this.gotoTop()
         return
      }
      if (this.subSource == "H5_DRIVER_INVITE" && (!this.formInfodata.supplierSelection || this.formInfodata.supplierSelection == "请选择供应商")) {
         this.$toast('供应商不能为空');
         this.isEmptySs = true // 展示供应商提示文案
         this.gotoTop()

      }
      if (!(this.isShowCardInfo || this.ocrSuccess || this.ocrFail || this.ocrCardBackSuccess || this.ocrCardBackFail)) {
        this.$toast('请上传身份证正面和背面照片')
        return
      }
      if (this.identityData.frontImg && !this.identityData.backImg) {
        this.$toast('请上传身份证背面照片')
        return
      }
      if (!this.identityData.frontImg && this.identityData.backImg) {
        this.$toast('请上传身份证正面照片')
        return
      }

      if (!this.formInfodata.driverName) {
        this.$toast('姓名不能为空');
        this.isEmptyDriverName = true
        this.gotoTop()
        return
      }
      if(!this.formInfodata.idCardNo) {
        this.$toast('身份证号不能为空');
        this.isEmptyIdCard = true
        this.gotoTop()
        return
      } else if (!idNumberReg.test(this.formInfodata.idCardNo)) {
        return
      }
      if(!this.formInfodata.sex) {
        this.$toast('性别不能为空');
        this.isEmptySex = true
        this.gotoTop()
        return

      }
      if(!this.formInfodata.idCardExpiryDate){
        this.$toast('有效截止日期不能为空');
        this.isEmptyIED = true
        this.gotoTop()
        return
      }
      // 驾驶证相关
      if(!(this.isShowDriverInfo || this.ocrDriverFrontSuccess || this.ocrDriverFrontFail || this.ocrDriverBackSuccess || this.ocrDriverBackFail)) {
        this.$toast('请上传驾驶证正面和背面照片')
        return
      }
      if (this.driverData.frontImg && !this.driverData.backImg) {
        this.$toast('请上传驾驶证背面照片')
        return
      }
      if (!this.driverData.frontImg && this.driverData.backImg) {
        this.$toast('请上传驾驶证正面照片')
        return
      }
      if (!this.formInfodata.driverLicenseClass) {
        this.$toast('驾驶证类型不能为空');
        this.goToBottom()
        this.isEmptyDLC = true
        return
      }
      if (!this.formInfodata.firstIssueDate) {
        this.$toast('驾驶证初次领证日期不能为空');
        this.goToBottom()
        this.isEmptyFID = true
        return
      }
      if (!this.formInfodata.licenseExpiryDate) {
        this.$toast('驾驶证有效截止日期不能为空');
        this.goToBottom() 
        this.isEmptyLED = true
        return
      }
      if (!this.formInfodata.licenseFileNumber) {
        this.$toast('驾驶证档案编号不能为空');
        this.goToBottom()
        this.isEmptyLFN = true
        return
      }
      if (!this.electronicDriverData.frontImg) {
        this.$toast('电子驾驶证不能为空');
      }
        return;
      }
    },
    // 回到页面底部
    goToBottom () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop === document.body.scrollHeight) return
      window.scrollTo(0, document.body.scrollHeight)
    },
    // 回到页面顶部
    gotoTop() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop === 0 ) return
      window.scrollTo(0, 0)
    },
    //审核失败点击重新提交和联系客服
    updataExamine(val) {
      //1为审核中2为审核失败3为审核成功
      if (val === "2") {
        // 重新填报
        this.active = 1;
        handleBuryPoint("recruiting-Audit", "toResubmit_Click", {});
        handleBuryPoint("recruiting-Information", "show", {});
      } else if (val === "3") {
        handleBuryPoint(
          "recruiting-Approved",
          "contactCustomerService_Click",
          {}
        );
        // 联系客服
        if (this.serviceTel) {
          if (this.$route.query.isInnerApp) {
            var obj = {
              action: "showPanellist",
              list: [
                {
                  title: `拨打电话：${this.serviceTel}`,
                  content: this.serviceTel
                }
              ]
            };
            window.AmapApp.bridge.send(obj);
          } else {
            window.location.href = "tel:" + this.serviceTel;
          }
        } else {
          //没有客服的处理
          this.$toast("网络不稳定，请刷新页面重试");
        }
      }
    },
    //展示示例
    examples(obj) {
      this.examplesImg = obj;
      this.show = true;
    },
    //关闭示例
    examplesClose() {
      this.show = false;
    },
    // 上传身份证相关信息到ocr
    async getOcrCardInfo(pic, key, isfront) {
      const defaultparams = {
        tenantId: this.tenantId,
        domainType: 200,
        imageUrl: pic,
        cardSide: key == "front" ? "FRONT" : "BACK",
        transId:this.transId
      };
      this.showCardInfoTips = null;
      console.log(defaultparams, "身份证ocr参数");
      const ocrCardData = await reqOcrCardInfo(defaultparams);
      console.log(ocrCardData, " OCR识别信息");
      if (ocrCardData.code === 1) {
        this.showCardInfoTips = false;
        const { name, idCardNo, sex, callOcr, expiryDate, message } =
          ocrCardData && ocrCardData.data;
        if (isfront == "1" && key == "front") {
          if (callOcr) {
            this.ocrSuccess = true;
            this.ocrFail = false;
            this.checkFrontOrBack = key;
            this.formInfodata.driverName = name;
            this.formInfodata.sex = sex == 1 ? "男" : "女";
            this.formInfodata.idCardNo = idCardNo;
            this.formInfodata.idCardExpiryDate = expiryDate;
            this.grcCardMessage = message;
            if (!sex) {
              this.formInfodata.sex = "";
            }
          } else {
            this.ocrSuccess = false;
            this.ocrFail = false;
            this.isShowCardInfo = true;
            const { idCardExpiryDate } = this.formInfodata;
            if (idCardExpiryDate === "Invalid Date") {
              this.formInfodata.idCardExpiryDate = "";
            }
          }
        } else if (isfront == "1" && key == "back") {
          if (callOcr) {
            this.ocrCardBackSuccess = true;
            this.ocrCardBackFail = false;
            this.checkFrontOrBack = key;
            this.formInfodata.idCardExpiryDate = expiryDate;
            this.grcCardBackMessage = message;
          } else {
            this.ocrCardBackSuccess = false;
            this.ocrCardBackFail = false;
            this.isShowCardInfo = true;
          }
        }
      } else {
        const { idCardExpiryDate } = this.formInfodata;
        this.showCardInfoTips = false;
        if (isfront == "1" && key == "front") {
          this.ocrSuccess = false;
          this.ocrFail = true;
          this.grcCardMessage = "";
          this.checkFrontOrBack = key;
          if (idCardExpiryDate === "Invalid Date") {
            this.formInfodata.idCardExpiryDate = "";
          }
        } else if (isfront == "1" && key == "back") {
          this.ocrCardBackSuccess = false;
          this.ocrCardBackFail = true;
          this.checkFrontOrBack = key;
          this.grcCardBackMessage = "";
          if (idCardExpiryDate === "Invalid Date") {
            this.formInfodata.idCardExpiryDate = "";
          }
        }
      }
    },
    // 上传驾驶证相关信息识别
    async getOcrDriverInfo(pic, key, isfront) {
      const defaultparams = {
        tenantId: this.tenantId,
        domainType: 200,
        imageUrl: pic,
        cardSide: key == "front" ? "FRONT" : "BACK",
        transId:this.transId
      };
      this.showDriverTipsInfo = null;
      console.log(defaultparams, "驾驶证ocr参数");
      const ocrDriverData = await reqOcrDriverInfo(defaultparams);
      console.log(ocrDriverData, " OCR识别驾驶证信息");
      if (ocrDriverData.code === 1) {
        const {
          callOcr,
          message,
          driverLicenseClass,
          firstIssueDate,
          licenseExpiryDate
        } = ocrDriverData.data || {};
        this.showDriverTipsInfo = false;
        if (isfront == "2" && key == "front") {
          if (callOcr) {
            console.log(isfront, "----");
            console.log(key, "----");
            this.ocrDriverFrontSuccess = true;
            this.ocrDriverFrontFail = false;
            this.checkDriverFrontOrBack = key;
            this.grcDriverCardMessage = message;
            this.formInfodata.driverLicenseClass = driverLicenseClass;
            this.formInfodata.firstIssueDate = firstIssueDate;
            this.formInfodata.licenseExpiryDate = licenseExpiryDate;
          } else {
            this.ocrDriverFrontSuccess = false;
            this.ocrDriverFrontFail = false;
            this.isShowDriverInfo = true;
            const {
              driverLicenseClass,
              firstIssueDate,
              licenseExpiryDate
            } = this.formInfodata;
            if (
              firstIssueDate === "Invalid Date" ||
              licenseExpiryDate === "Invalid Date"
            ) {
              this.formInfodata.driverLicenseClass = "";
              this.formInfodata.firstIssueDate = "";
              this.formInfodata.licenseExpiryDate = "";
            }
          }
        } else if (isfront == "2" && key == "back") {
          if (ocrDriverData.data && ocrDriverData.data.callOcr) {
            this.ocrDriverBackSuccess = true;
            this.ocrDriverBackFail = false;
            this.checkDriverFrontOrBack = key;
            this.grcDriverBackCardMessage = message;
            this.formInfodata.licenseFileNumber =
              ocrDriverData.data.licenseFileNumber;
          } else {
            this.ocrDriverBackSuccess = false;
            this.ocrDriverBackFail = false;
            this.isShowDriverInfo = true;
            this.formInfodata.licenseFileNumber = "";
            const {
              driverLicenseClass,
              firstIssueDate,
              licenseExpiryDate
            } = this.formInfodata;
            if (
              firstIssueDate === "Invalid Date" ||
              licenseExpiryDate === "Invalid Date"
            ) {
              this.formInfodata.driverLicenseClass = "";
              this.formInfodata.firstIssueDate = "";
              this.formInfodata.licenseExpiryDate = "";
            }
          }
        }
      } else {
        this.showDriverTipsInfo = false;
        this.grcDriverCardMessage = "";
        this.grcDriverBAackCardMessage = "";
        if (isfront == "2" && key == "front") {
          this.ocrDriverFrontSuccess = false;
          this.ocrDriverFrontFail = true;
          this.checkDriverFrontOrBack = key;
          const {
            driverLicenseClass,
            firstIssueDate,
            licenseExpiryDate
          } = this.formInfodata;
          if (
            firstIssueDate === "Invalid Date" ||
            licenseExpiryDate === "Invalid Date"
          ) {
            this.formInfodata.driverLicenseClass = "";
            this.formInfodata.firstIssueDate = "";
            this.formInfodata.licenseExpiryDate = "";
          }
        } else if (isfront == "2" && key == "back") {
          this.ocrDriverBackSuccess = false;
          this.ocrDriverBackFail = true;
          this.checkDriverFrontOrBack = key;
          this.formInfodata.licenseFileNumber = "";
        }
      }
    },
    // 已扣12分弹框事件
    handleAction (event) {
      this.isElectronicResult = true
      if (event == 'confirm') {
        this.showElectronicDialog = false
        this.electronicStatus = true
      } else if (event == 'cancel') {
        this.showElectronicDialog = false
        this.electronicStatus = false
      }
    },
    handlePaperAction (event) {
      this.isElectronicResult = true
      if (event == 'confirm') {
        this.showElectronicPaperDialog = false
      } else if (event == 'cancel') {
        this.showElectronicPaperDialog = false
        this.confirmStatus = 1
        this.submitFormInfo();
      }
    },
    // 上传电子驾驶证相关信息识别
    async getOcrElectronicInfo(pic, key) {
      const defaultparams = {
        tenantId: this.tenantId,
        domainType: 200,
        imageUrl: pic,
        cardSide: key == "front" ? "FRONT" : "BACK",
        transId:this.transId
      };
      const electronicData = await reqOcrElectronicInfo(defaultparams)
      console.log(electronicData, '获取电子驾照信息')
      if (electronicData.code === 1) {
        this.isElectronicResult = true
        if (electronicData.data && electronicData.data.callOcr) {
          this.electronicMessage = electronicData.data.message
          this.cumulativeScore = electronicData.data.cumulativeScore
          this.generateTime = electronicData.data.generateTime
          this.ocrElectronicSuccess = true
          this.ocrElectronicFail = false
          this.electronicStatus = false
          this.newelectronicMessage = ''
        } else {
          this.ocrElectronicFail = true
          this.ocrElectronicSuccess = false
        }
      } else 
      // if (electronicData.code === 600002){
      //   // this.showElectronicDialog = true
      //   this.electronicDailogMessage = '系统识别到您的驾照已扣12分， 请按照交管部门规定，处理销分后，再进行信息填报'
      //   this.electronicDailogtitle = '驾照分不足'
      //   this.cancelButtonText = '继续填报，由平台人工审核'
      //   this.confirmButtonText = '我已知晓，退出填报'
      //   this.electronicMessage = electronicData.data.message
      //   this.cumulativeScore = electronicData.data.cumulativeScore
      //   this.generateTime = electronicData.data.generateTime
      //   this.newelectronicMessage = ''
      //   this.ocrElectronicSuccess = true
      //   this.ocrElectronicFail = false
      // } else if (electronicData.code === 600003) {
      //     this.isElectronicResult = true
      //     this.ocrElectronicSuccess = true
      //     this.ocrElectronicFail = true
      //     this.newelectronicMessage = electronicData.data.message
      // } else
       {
        this.ocrElectronicFail = true
        this.electronicStatus = false
        this.electronicMessage = ''
        this.newelectronicMessage = ''
        this.isElectronicResult = true
      }
    },
    //上传时设置图片信息
    srcValue(obj) {
      if (obj.credentialsKey === "1" && obj.credentialsListKey === "front") {
        handleBuryPoint("recruiting-Certificate", "idCardFaceUpload_Click", {});
        console.log("身份证正面");
        console.log(obj.data, "上传时");
        if (obj.data) {
          this.getOcrCardInfo(
            obj.data,
            obj.credentialsListKey,
            obj.credentialsKey
          );
        }
        this.identityData.severFrontImg = obj.data; //服务需要的图片
        this.identityData.frontImg = obj.pageSrc; //回显需要的图片
        this.identityData.frontText = "身份证人像面";
      }
      if (obj.credentialsKey === "1" && obj.credentialsListKey === "back") {
        handleBuryPoint(
          "recruiting-Certificate",
          "idCardNationalEmblemUpload_Click",
          {}
        );
        console.log("身份证反面");
        this.getOcrCardInfo(
          obj.data,
          obj.credentialsListKey,
          obj.credentialsKey
        );
        this.identityData.severBackImg = obj.data; //服务需要的图片
        this.identityData.backImg = obj.pageSrc; //回显需要的图片
        this.identityData.backText = "身份证国徽面";
      }
      if (obj.credentialsKey === "2" && obj.credentialsListKey === "front") {
        handleBuryPoint(
          "recruiting-Certificate",
          "homePageOfDrivingLicense_Click",
          {}
        );
        console.log("驾驶证正面");
        if (obj.data) {
          this.getOcrDriverInfo(
            obj.data,
            obj.credentialsListKey,
            obj.credentialsKey
          );
        }
        this.driverData.severFrontImg = obj.data; //服务需要的图片
        this.driverData.frontImg = obj.pageSrc; //回显需要的图片
        this.driverData.frontText = "驾驶证首页";
      }
      if (obj.credentialsKey === "2" && obj.credentialsListKey === "back") {
        handleBuryPoint(
          "recruiting-Certificate",
          "subPageOfDrivingLicense_Click",
          {}
        );
        console.log("驾驶证反面");
        this.getOcrDriverInfo(
          obj.data,
          obj.credentialsListKey,
          obj.credentialsKey
        );
        this.driverData.severBackImg = obj.data; //服务需要的图片
        this.driverData.backImg = obj.pageSrc; //回显需要的图片
        this.driverData.backText = "驾驶证副页";
      }
      if (obj.credentialsKey === "3" && obj.credentialsListKey === "front"){
        this.isElectronicResult = false
        handleBuryPoint(
          "recruiting-Certificate",
          "subPageOfElectronicLicense_Click",
          {}
        );
        if(obj.data) {
          console.log("电子驾驶证");
          this.getOcrElectronicInfo(obj.data, obj.credentialsListKey);
        }
        this.electronicDriverData.severFrontImg = obj.data; //服务需要的图片
        this.electronicDriverData.frontImg = obj.pageSrc; //回显需要的图片
        this.electronicDriverData.frontText = "电子版驾驶证";
      }
    },
    // 断网状态
    refresh() {
      console.log("网络状态");
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-action-sheet__header{
  font-weight: bold;
  font-size: 40px;
  line-height: 20px;
  padding-top: 50px;
  border: none;
}
/deep/ .van-action-sheet__description{
  font-weight: 400;
  font-size: 28px;
  line-height: 10px;
  border: none;
}
/deep/ .van-action-sheet__close{
  top:48px;
}
.actioncontent{
  padding: 0 30px;
  img{
    width: 100%;
  }
}
.home {
  background: #f5f5f5;
  padding-top: 20px;
}
.home-main {
  padding: 0 16.5px 140px 16.5px;
}
.home-bottom {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  margin: 60px 40px 0 40px;
  height: 100px;
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn_wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  width: 100%;
  height: 154px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 19px 1px rgba(200, 200, 200, 1);
}
.info_content_dis_btn {
  background: #c8c9cd;
  border-radius: 16px;
  width: 670px;
  height: 100px;
  margin: 0 auto;
  font-size: 32px;
  color: #ffffff;
  line-height: 100px;
  text-align: center;
}
.info_content_btn {
  background-image: linear-gradient(270deg, #27a0ff 0%, #176af0 100%);
}
.city_tips {
  padding: 25px;
  font-size: 30px;
  color: #999999;
  display: flex;
  justify-content: center;
  .city_tips_content {
    width: 670px;
    img {
      position: relative;
      top: -4px;
      width: 34px;
      height: 34px;
    }
  }
}
.city_tips_new{
  img{
    width: 26px;
    height: 26px;
    position: relative;
    top: -3px;
  }
  font-size: 24px;
  color: #e30000;
  padding: 25px;
}

.all_city {
  background: #ffffff;
  border-radius: 18px;
  margin-bottom: 17px;
}
.check_city_gray {
  background: #f3f3f3 !important;
}
.check_city {
  height: 112px;
  line-height: 112px;
  font-size: 32px;
  color: #333333;
  padding: 0px 24px;
  .city_gray {
    color: #c4c4c6;
  }
  ul {
    height: 112px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e0e0e0;
    li {
      width: 50%;
      padding: 0px 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      span {
        display: flex;
        justify-content: space-between;
        img {
          width: 40px;
          height: 20px;
        }
      }
    }
    li:nth-of-type(1) {
      padding: 0px;
    }
    li:nth-of-type(2) {
      padding-right: 0px;
    }
  }
}
.c_t_b{
  border-bottom: 1px solid #e30000 !important;
}
.supplierSelection {
  ul {
    li {
      display: flex;
      justify-content: space-between;
      padding: 0px 24px;
      font-size: 32px;
      color: #333333;
      height: 112px;
      line-height: 112px;
      border-bottom: 1px solid #e0e0e0;
      p:nth-of-type(2) {
        span:first-child {
          color: #176af0;
          padding-right: 30px;
        }
      }
      img {
        width: 40px;
        height: 20px;
      }
    }
  }
}
.global_gray {
  color: #c4c4c6 !important;
}
.info_content_box {
  background: #ffffff;
  border-radius: 18px;
  margin-bottom: 16px;
  padding: 10px 0px 20px;
}
.info_around {
  display: flex;
  justify-content: center;
  font-size: 28px;
  color: #176af0;
  height: 100px;
  background: #ffffff;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  align-items: center;
  font-weight: 400;
  margin-bottom: 20px;
  img {
    display: flex;
    width: 20px;
    height: 20px;
    margin-top: 3px;
    margin-left: 6px;
  }
  .rotate_img {
    transform: rotate(90deg);
  }
}
/deep/ .van-image-preview__cover {
  position: relative;
}
.preview {
  width: 100%;
  .preview_top {
    width: 100%;
    height: 208px;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0px;
  }
  .preview_bottom {
    width: 100%;
    height: 208px;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 9000;
  }
  .delete {
    position: absolute;
    bottom: 100px;
    right: 30px;
    width: 115px;
    height: 58.04px;
    z-index: 100000 !important;
    line-height: 58.04px;
    text-align: center;
    background: #3483ff;
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #ffffff;
    font-weight: 400;
  }
}
</style>
